import React from "react";

const SortFilter = ({ type, sortFilterData, changeSort, reviewsSummary }) => {
  const ratingDistribution =
    reviewsSummary && reviewsSummary.ratingDistribution
      ? reviewsSummary.ratingDistribution
      : {};

  return (
    <div className="lg:px-6 py-4 flex flex-row flex-wrap lg:bg-gray-lighter">
      <div className="inline-block w-1/2 md:w-auto pr-1 lg:pr-0">
        <label className="block md:inline-block md:pr-2">Sorteaza</label>{" "}
        <div
          className={`Form-select Form-select--small md:inline-block max-w-full ${
            type == "review" ? "pr-1" : ""
          }`}
        >
          <select
            value={undefined}
            name="sortare"
            onChange={(e) => {
              changeSort({
                ...sortFilterData,
                sortBy: e.target.value === "populare" ? "upvotes" : "date",
              });
            }}
            className="max-w-fulli w-full md:w-auto"
          >
            <option value="recente">Cele mai recente primele</option>
            <option value="populare">
              {type === "reviews" ? "Cele mai populare" : "Cele mai votate"}
            </option>
          </select>
        </div>
      </div>

      {type === "reviews" && (
        <>
          <div className="inline-block w-1/2 md:w-auto pl-1 lg:pl-0 md:pr-6">
            <label className="block md:inline-block md:pl-6 md:pr-1">
              Afiseaza
            </label>{" "}
            <div className="Form-select Form-select--small md:inline-block max-w-full pl-1">
              <select
                name="vizualizare"
                value={sortFilterData.rating ?? "toate"}
                onChange={(e) => {
                  const newSort = { ...sortFilterData };
                  if (e.target.value === "toate") {
                    delete newSort.rating;
                  } else {
                    newSort.rating = parseInt(e.target.value);
                  }
                  changeSort(newSort);
                }}
                className="max-w-fulli w-full md:w-auto"
              >
                <option value="toate">Toate recenziile</option>
                {[1, 2, 3, 4, 5].map((star) =>
                  ratingDistribution[star] ? (
                    <option key={`option-stars-${star}`} value={star}>
                      {star === 1
                        ? `Doar recenziile cu 1 stea`
                        : `Doar recenziile cu ${star} stele`}
                    </option>
                  ) : null
                )}
              </select>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SortFilter;
